import React, {useState, useEffect} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import _ from "lodash";
import Input from "../../forms/Input";
import Button from "../../Button";
import AssignProducts from "./products/AssignProducts";

const QUOTE_DEFAULTS = {
    id:                     '',
    job_id:                 '',
    template_setting_id:    '',
    name:                   '',
    product_ids:            [],
    includeLineItems:       false,
}

const CreateEditQuote = (props) => {
    const {
        jobId = null,
        quoteId = null,
        onCancel = () => {},
        onComplete = () => {},
    } = props;

    const prepareDefaultValues = () => {
        const defaultProduct = QUOTE_DEFAULTS;

        if (!!quoteId && quoteId !== "") {
            defaultProduct.id = parseInt(quoteId);
        }

        return defaultProduct;
    }

    const [submitting, setSubmitting]               = useState(false);
    const [templateSettings, setTemplateSettings]   = useState([]);
    const [availableProducts, setAvailableProducts] = useState([]);
    const [job, setJob]                             = useState(null);
    const [quote, setQuote]                         = useState(prepareDefaultValues());
    const [errors, setErrors]                       = useState(null);

    useEffect(() => {
        load();
    }, [jobId, quoteId]);

    const load = () => {
        axios.get(route('web-api.job.quote.config', {job: jobId, quote_id: quoteId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.products) {
                        setAvailableProducts(response.data.products);
                    }

                    if (!!response.data.template_settings) {
                        setTemplateSettings(response.data.template_settings);
                    }

                    if (!!response.data.quote) {
                        setQuote(response.data.quote);
                    } else {
                        setQuote(QUOTE_DEFAULTS);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const reset = () => {
        setQuote(prepareDefaultValues());

        setSubmitting(false);
        setErrors(null);
    }

    const handleClickIncludeLineItemsCheckbox = () => {
        const quoteClone = _.cloneDeep(quote);
        quoteClone.includeLineItems = !quoteClone.includeLineItems;
        setQuote(quoteClone);
    }

    const payload = () => {
        return {
            method: !!quoteId ? 'patch' : 'post',
            url:    !!quoteId ? route('web-api.job.quote.update', {job: jobId, quote: quoteId}).toString() : route('web-api.job.quote.store', {job: jobId}).toString(),
            data:   {
                ...quote,
                allProducts: availableProducts,
            },
        }
    }

    const submit = () => {
        const data = payload();
        axios(data)
            .then((response) => {
                reset();
                onComplete(response.data.quote_id);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }

                setSubmitting(false);
            });
    }

    const handleClose = () => {
        if (!submitting) {
            reset();
            onCancel();
        }
    }

    const onChange = (field, value) => {
        const clone = _.cloneDeep(quote);

        clone[field] = value;

        setQuote(clone);
        if (field === "order_index") {
            setAvailableProducts(value);
        }
    }

    return (
        <React.Fragment>
            <div className="row m-0 p-0">
                <div className="col-12 col-lg-6 m-0 p-0 pr-lg-2 bespoke-input">
                    <Input
                        name={"name"}
                        label={"Quote Name"}
                        required={true}
                        type={"text"}
                        value={quote.name}
                        disabled={submitting}
                        onChange={(value) => onChange("name", value)}
                        error={!!errors && !!errors.name ? errors.name : null}
                    />
                </div>
                <div className="col-6 m-0 p-0 bespoke-input">
                    <Input
                        name={"template_setting_id"}
                        label={"Quote Template"}
                        required={true}
                        type={"searchable-select"}
                        options={templateSettings}
                        value={quote.template_setting_id}
                        disabled={submitting}
                        onChange={(value) => onChange("template_setting_id", value)}
                        error={!!errors && !!errors.template_setting_id ? errors.template_setting_id : null}
                    />
                </div>
            </div>
            <div className="ml-auto mt-2">
                <label
                    className="mr-2"
                >
                    Include line item costs
                </label>
                <input
                    type="checkbox"
                    checked={quote.includeLineItems}
                    onChange={handleClickIncludeLineItemsCheckbox}
                />
            </div>
            <div className="row m-0 mb-4 p-0 pb-2 border-bottom">
                <div className="col-12 m-0 p-0">
                    <AssignProducts
                        availableProducts={availableProducts}
                        productIds={quote.product_ids}
                        onChange={(field, value) => onChange(field, value)}
                        disabled={submitting}
                        errors={errors}
                    />
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center">
                        <Button
                            onClick={() => setSubmitting(true)}
                            label={!!quoteId ? "Save Changes" : "Create"}
                            classes={"btn btn-eh-lilac m-0 mr-4"}
                        />
                        <Button
                            onClick={() => handleClose()}
                            label={"Cancel"}
                            classes={"btn btn-outline-eh-off-black m-0 mr-4"}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default CreateEditQuote;
